import { MouseEvent } from "react";
import HoverAuthorizeTooltip from "components/authorize/AuthorizeTooltip";
import DragIcon from "assets/svg/drag.svg";
import eventEditIcon from "assets/svg/event-edit.svg";
import CloseOutlined from "@mui/icons-material/CloseOutlined";

type ActionLayoutProps = {
    children: React.ReactNode;
    showDeleteConfirm: () => void;
    editAction: (
        e?: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
    ) => void;
    renderActionIcon: () => React.ReactNode;
};

const ActionLayout = ({
    children,
    showDeleteConfirm,
    editAction,
    renderActionIcon,
}: ActionLayoutProps) => {
    return (
        <div className="event-action-item">
            <div>{renderActionIcon()}</div>
            <div className="event-action-content">{children}</div>
            <div>
                <HoverAuthorizeTooltip
                    permission="event:update"
                    className="event-edit"
                >
                    <button
                        className="icon-btn"
                        onClick={editAction}
                        aria-label="edit-action"
                    >
                        <img
                            width={19}
                            height={19}
                            src={eventEditIcon}
                            alt="Edit Action"
                        />
                    </button>
                </HoverAuthorizeTooltip>
            </div>
            <div>
                <HoverAuthorizeTooltip
                    permission="event:update"
                    className="drag-action"
                >
                    <img
                        className="grid-stack-item-content"
                        width={24}
                        height={24}
                        src={DragIcon}
                        alt="drag"
                    />
                </HoverAuthorizeTooltip>
                <HoverAuthorizeTooltip
                    permission="event:delete"
                    className="remove-action"
                >
                    <CloseOutlined
                        aria-label="delete-action"
                        onClick={showDeleteConfirm}
                        onKeyDown={showDeleteConfirm}
                        style={{ color: "#f2495e", cursor: "pointer" }}
                    />
                </HoverAuthorizeTooltip>
            </div>
        </div>
    );
};

export default ActionLayout;
